// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__TF0lP","type":"styles_type__3Nsjd","choices":"styles_choices__11vVt"};